import React from "react";
import { createPortal } from "react-dom";
import { Box } from "@mui/material";

const TabContentOverlay = ({ isOpen, onClose, children, anchorId }) => {
  if (!isOpen) return null;

  const portalTarget = document.getElementById(`tab-content-overlay-${anchorId}`);
  if (!portalTarget) return null;

  return createPortal(
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1300,
      }}
    >
      {children}
    </Box>,
    portalTarget
  );
};

export default TabContentOverlay;
